import {
  MODULES_AI_CHAT,
  MODULES_BROKERAGE,
  MODULES_CMA_REPORTS,
  MODULES_LEADS,
  MODULES_PROSPECTION_MAP,
  MODULES_PROSPECTION_MAP_V2,
  MODULES_VALUATION_LINK,
  MODULES_VISIBILITY,
  ModuleId,
} from '@shared/constants/module';
import type { Translate } from '@shared/hooks/locale';

export const CRM_MODULE_IDS_FOR_DISPLAY = [
  MODULES_VISIBILITY,
  MODULES_LEADS,
  MODULES_PROSPECTION_MAP,
  MODULES_PROSPECTION_MAP_V2,
  MODULES_BROKERAGE,
  MODULES_CMA_REPORTS,
  MODULES_VALUATION_LINK,
  MODULES_AI_CHAT,
] as const;

const MODULE_LABEL_MAP: Record<string, (t: Translate) => string> = {
  [MODULES_LEADS]: t => t('Leads'),
  [MODULES_PROSPECTION_MAP]: t => t('Prospection map'),
  [MODULES_PROSPECTION_MAP_V2]: t => t('Prospection map (new)'),
  [MODULES_BROKERAGE]: t => t('Brokerage'),
  [MODULES_CMA_REPORTS]: t => t('CMA reports'),
  [MODULES_VALUATION_LINK]: t => t('Valuation link'),
  [MODULES_VISIBILITY]: t => t('Visibility'),
  [MODULES_AI_CHAT]: t => t('AI Chat'),
  [ModuleId.Financing]: t => t('Financing'),
};

export function getModuleLabel(module: string, t: Translate): string {
  return MODULE_LABEL_MAP[module]?.(t) ?? module;
}

export function getModuleSelectOptions(t: Translate) {
  return CRM_MODULE_IDS_FOR_DISPLAY.map(value => ({
    label: getModuleLabel(value, t),
    value,
  }));
}
